import { error } from '@ms/yammer-console-logging';

export const getKeys = (): string[] => {
  const keys: string[] = [];
  const count = localStorage.length;
  for (let index = 0; index < count; index++) {
    const key = localStorage.key(index);
    if (key != null) {
      keys.push(key);
    }
  }

  return keys;
};

export const getItem = <T>(key: string): T | null => {
  const item = localStorage.getItem(key);

  return item ? (JSON.parse(item) as T) : null;
};

export const setItemOrThrow = (key: string, item: unknown): void => {
  localStorage.setItem(key, JSON.stringify(item));
};

export const setItem = (key: string, item: unknown): void => {
  try {
    setItemOrThrow(key, item);
  } catch (e) {
    error(e);
  }
};

type RemoveItem = (key: string) => void;
export const removeItem: RemoveItem = (key: string) => {
  localStorage.removeItem(key);
};

type Clear = () => void;
export const clear: Clear = () => {
  localStorage.clear();
};
